import React, { useState, useEffect } from 'react'
import Chart from 'react-google-charts'
import { useNavigate } from 'react-router-dom'
import { connect } from 'react-redux'
import * as R from 'ramda'
import { findByName, findById } from '../../js/countries'

function WorldChart({ countryData }) {
  const navigate = useNavigate()
  const [size, setSize] = useState({
    width: 0,
    height: 0,
  })

  useEffect(() => {
    window.addEventListener('resize', onResize)
    onResize()
    return () => {
      window.removeEventListener('resize', onResize)
    }
  }, [])

  const onResize = () => {
    const windowWidth = window.innerWidth

    setSize({
      width: windowWidth,
      height: (windowWidth * 5) / 9,
    })
  }

  const onCountrySelected = ({ chartWrapper }) => {
    const chart = chartWrapper.getChart()
    const selection = chart.getSelection()
    if (selection.length === 1) {
      const [selectedItem] = selection
      const { row } = selectedItem
      const dataTable = chartWrapper.getDataTable()
      const countryName = dataTable.getValue(row, 0)
      const country = findByName(countryName)
      if (country.id === 236 || country.id === 14 || country.id === 40) {
        navigate(`/region/${country.short}`)
      } else {
        navigate(`/country/${country.short}`)
      }
    }
  }

  const onMouseOver = (e) => {
    console.log('onMouseOver', e)
  }
  const onMouseOut = (e) => {
    console.log('onMouseOut', e)
  }

  const options = {
    colors: ['#08c'],
    legend: 'none',
    tooltip: { trigger: 'none' },
  }

  const { width, height } = size

  if (width === 0 || height === 0) return null

  console.log(countryData)

  return (
    <div
      className="world-chart-wrapper"
      style={{ height }}
      onMouseEnter={onMouseOver}
      onMouseLeave={onMouseOut}
    >
      <Chart
        width={width}
        height={height}
        key={height /* triggers reload on resize window */}
        chartType="GeoChart"
        data={countryData}
        options={options}
        mapsApiKey={process.env.REACT_APP_CHARTS_KEY}
        chartEvents={[
          {
            eventName: 'select',
            callback: onCountrySelected,
          },
        ]}
      />
    </div>
  )
}

const mapStateToProps = (state) => {
  const groups = state.groups.data
  const groupedByCountry = R.groupBy((group) => group.country, groups)
  const groupsData = Object.keys(groupedByCountry)
    .filter((countryCode) => !!countryCode && countryCode > 0)
    .map((countryCode) => {
      const courseCount = R.sum(
        groupedByCountry[countryCode].map((group) => group.count)
      )
      return [findById(countryCode).name, courseCount]
    })

  return {
    countryData: R.concat([['Country', 'Popularity']], groupsData),
  }
}

export default connect(mapStateToProps)(WorldChart)
